import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import moment from 'moment';

@Pipe({
    name: 'kdDateFormat',
})
export class KdDateFormatPipe implements PipeTransform {
    constructor(@Inject(LOCALE_ID) protected localeId: string) {
        // Normalize Angular's generic 'en' locale to a full Moment locale id
        this.localeId = localeId === 'en' ? 'en-US' : localeId;
    }
    transform(value: moment.MomentInput, format?: string): string {
        return value ? (value = moment(value).locale(this.localeId).format(format)) : '';
    }
}
